import React from 'react';

// ═══════════════════════════════════════════════════════════════════
//  CazaErrores — que un fallo NO deje la aplicación en blanco
//
//  En React, una excepción durante el pintado que nadie recoge desmonta
//  el árbol ENTERO. El resultado es una pantalla blanca: ni menú, ni
//  mensaje, ni nada. El usuario solo puede decir "se me queda en blanco",
//  que es exactamente lo que no sirve para arreglarlo.
//
//  Esto lo recoge y enseña un panel con:
//    · qué pantalla falló,
//    · el mensaje del error, tal cual,
//    · un botón para COPIARLO, que es lo que de verdad hace falta: con
//      ese texto el fallo se arregla en minutos en vez de a ciegas.
//
//  El menú y el resto de la aplicación siguen funcionando: solo se cae
//  el trozo de dentro.
//
//  `clave` hace que el panel se rearme solo al cambiar de pantalla: si
//  no, una vez roto se quedaría roto hasta recargar.
// ═══════════════════════════════════════════════════════════════════
export default class CazaErrores extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, pila: '' };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // A la consola también, con el árbol de componentes: es donde mira
    // quien pueda abrir las herramientas del navegador.
    // eslint-disable-next-line no-console
    console.error('[CazaErrores]', error, info?.componentStack);
    this.setState({ pila: info?.componentStack || '' });
  }

  componentDidUpdate(anterior) {
    // Al cambiar de pantalla se vuelve a intentar.
    if (this.state.error && anterior.clave !== this.props.clave) {
      this.setState({ error: null, pila: '' });
    }
  }

  texto() {
    const { error, pila } = this.state;
    return [
      `Pantalla: ${this.props.clave || '—'}`,
      `Fecha: ${new Date().toLocaleString('es-ES')}`,
      `Error: ${error?.name || 'Error'}: ${error?.message || error}`,
      '',
      (error?.stack || '').split('\n').slice(0, 12).join('\n'),
      '',
      'Componentes:',
      (pila || '').split('\n').slice(0, 12).join('\n'),
    ].join('\n');
  }

  copiar = async () => {
    const t = this.texto();
    try {
      await navigator.clipboard.writeText(t);
      this.setState({ copiado: true });
      setTimeout(() => this.setState({ copiado: false }), 2500);
    } catch {
      // Sin permiso de portapapeles (pasa en algún navegador de móvil):
      // se selecciona el texto para que se pueda copiar a mano.
      const caja = document.getElementById('caza-errores-texto');
      if (caja) { caja.focus(); caja.select(); }
    }
  };

  render() {
    const { error, copiado } = this.state;
    if (!error) return this.props.children;

    return (
      <div className="card" style={{ margin:'16px auto', maxWidth:760 }}>
        <div className="card-body" style={{ padding:20 }}>
          <div style={{ fontSize:38, lineHeight:1, marginBottom:10 }}>😵</div>
          <h2 style={{ margin:'0 0 6px', fontSize:19 }}>
            Esta pantalla se ha quedado a medias
          </h2>
          <p style={{ margin:'0 0 14px', color:'var(--rg-gray-600)', fontSize:14 }}>
            Ha fallado algo al pintarla. No se ha perdido nada de lo que hay
            guardado: lo que falla es lo que se ve. Prueba a recargar, y si
            vuelve a pasar, <strong>copia el detalle y mándalo</strong>, que
            con eso se arregla.
          </p>

          <div style={{ display:'flex', gap:8, flexWrap:'wrap', marginBottom:14 }}>
            <button className="btn btn-primary"
              onClick={() => window.location.reload()}>↻ Recargar</button>
            <button className="btn btn-secondary"
              onClick={() => { window.location.href = '/'; }}>Ir al inicio</button>
            <button className="btn btn-secondary" onClick={this.copiar}>
              {copiado ? '✓ Copiado' : '📋 Copiar el detalle'}
            </button>
          </div>

          <details>
            <summary style={{ cursor:'pointer', fontSize:13, color:'var(--rg-gray-600)' }}>
              Ver el detalle
            </summary>
            <textarea id="caza-errores-texto" readOnly value={this.texto()}
              onFocus={e => e.target.select()}
              style={{ width:'100%', height:200, marginTop:8, fontFamily:'monospace',
                fontSize:11, lineHeight:1.45, padding:10, borderRadius:'var(--radius-sm)',
                border:'1px solid var(--rg-gray-200)', background:'var(--rg-gray-50)',
                color:'var(--rg-gray-700)', resize:'vertical' }} />
          </details>
        </div>
      </div>
    );
  }
}
